import React, {useEffect} from 'react'
import {useTranslation} from 'react-i18next'
import compose from 'lodash/flowRight'
import {breadcrumbsStore, linksStore} from 'appBase/TopNav'
import withUriParams from 'hocs/withUriParams'
import EventView from './EventView'
import {LICENSE} from 'constants/constants'


const LicenseView = compose(
    withUriParams([
        ['eventId', String]]),
)((props) => {
    const {eventId, block, loading, noAccess} = props;
    const {t} = useTranslation();

    // preparing breadcrumbs
    const containerId = LICENSE;
    breadcrumbsStore.register(containerId);
    linksStore.register(containerId);
    const breadcrumbs = [];

    breadcrumbs.push({
        name: block ? block.props.name: t('appEvent.EventApp.unknownLicense'),
        to: props.uri,
        back: 1,
        nonBlocking: true });

    useEffect(() => {
        const isTerminalBreadcrumbs = !eventId;
        breadcrumbsStore.set(containerId, breadcrumbs, isTerminalBreadcrumbs);
        linksStore.set(containerId, [], isTerminalBreadcrumbs);
    });

    return (
        <>
            {!eventId &&
            <div className="flex-grow d-flex flex-column scroll-parent">
                <div className="flex-grow d-flex scroll-parent">
                    <div className="flex-grow scroll">
                        <h5 className="mt-3 fs-4 text-center text-dark">{t('appEvent.EventApp.licenseEvents')}</h5>
                        <div className="container">
                            {loading.events && t('appEvent.EventApp.loading')}
                            {noAccess && t('appEvent.EventApp.noAccess')}

                            {block}

                        </div>
                    </div>
                </div>
            </div>}

            {eventId && /* eventId is either normal event.id or event.link_uuid */
            <EventView eventId={eventId}
                       showBackLink
                       user={props.user} errors={props.errors} loading={loading} refetch={props.refetch}
                       setActionLockWithMessageAndActions={props.setActionLockWithMessageAndActions}
                       resetActionLock={props.resetActionLock}
                       executeWithLock={props.executeWithLock}
                       executeWithConfirmation={props.executeWithConfirmation}
                       uri={`${props.uri}/${eventId}`} uriParams={props.uriParams} location={props.location} />}
        </>);
});

export default LicenseView;